import React from 'react';
import './Summary.css';

const Summary = ({ data }) => {
  return (
    <div className="toolRendersMONAD-summary">
      <div className="toolRendersMONAD-summary__title">{data.topic}</div>
      <div className="toolRendersMONAD-summary__goal">{data.end_goal}</div>
      
      <div className="toolRendersMONAD-summary__notes">
        {data.notes.map((note, index) => (
          <div 
            key={index} 
            className="toolRendersMONAD-summary__note"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            {note}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Summary;